.backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  backdrop-filter: blur(2px);
  transition: opacity 150ms ease;
}

.viewport {
  position: fixed;
  inset: 0;
  z-index: 51;
  display: grid;
  place-items: center;
  padding: var(--space-4);
  pointer-events: none;
}

.popup {
  box-sizing: border-box;
  width: min(34rem, 100%);
  pointer-events: auto;

  background: var(--color-surface);
  color: var(--color-text-dark);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow:
    0 24px 64px var(--color-box-shadow-bold),
    var(--shadow-md);

  padding: var(--space-6);
  font-family: var(--font-family-base);

  transition:
    opacity 150ms ease,
    transform 150ms ease;

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    transform: translateY(0.375rem) scale(0.98);
  }
}

.longPopup {
  composes: popup;
  width: min(40rem, 100%);
}

.title {
  margin: 0;
  color: var(--color-text-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.description {
  margin: var(--space-4) 0 0;
  color: var(--color-text-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-normal);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  margin-top: var(--space-6);
}

.button {
  min-height: 2.5rem;
  padding: 0 var(--space-3);
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;

  font: inherit;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.01em;
  text-transform: none;

  cursor: pointer;
  transition:
    background-color 150ms ease,
    color 150ms ease,
    box-shadow 150ms ease;
}

.button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-focus-ring);
}

.secondaryButton {
  composes: button;
  color: var(--color-text-muted);
}

.secondaryButton:hover {
  background: var(--color-surface-subtle);
  color: var(--color-text);
}

.primaryButton {
  composes: button;
  color: var(--color-primary);
}

.primaryButton:hover {
  background: var(--color-primary-subtle);
  color: var(--color-primary-hover);
}
